import TopBar from "@/components/top-bar";
import EducatorsAboutSection from "@/features/educators/components/educators-about-section";
import EducatorsBenefitsSection from "@/features/educators/components/educators-benefits-section";
import EducatorsFeatureCardsSection from "@/features/educators/components/educators-feature-cards-section";
import EducatorsInfoSection from "@/features/educators/components/educators-info-section";
import EducatorsPublishButton from "@/features/educators/components/educators-publish-button";
import EducatorsFooter from "./educators-footer";

export default function EducatorsLanding() {
  return (
    <main dir="rtl" className="w-full bg-secondary-background">
      <TopBar href={"/"} bare />
      <section className="relative w-full overflow-hidden mb-32">
        <img
          src="/educator-assets/hero.webp"
          alt="دوره‌های آموزیم"
          className="pointer-events-none absolute inset-x-0 -top-10 w-full select-none"
        />

        <div className="relative z-10 flex flex-col items-center px-4 pt-[calc(100%+90px)] text-center gap-4">
          <h1 className="text-xl font-extrabold leading-9 text-foreground">
            دوره هاتو تو آموزیم قسطی بفروش
          </h1>

          <EducatorsPublishButton className="rounded-full bg-[#0d152a] px-5" />
        </div>
      </section>

      <EducatorsInfoSection />
      <EducatorsBenefitsSection />
      <EducatorsFeatureCardsSection />
      <div className="h-12 w-full"></div>
      <EducatorsAboutSection />
      <div className="h-12 w-full"></div>
      <EducatorsFooter />
    </main>
  );
}
